import { HttpContextToken } from '@angular/common/http';

export const BYPASS_CLIENT_LOGGING = new HttpContextToken<boolean>(() => false);
export const BYPASS_LOADER = new HttpContextToken<boolean>(() => false);